/** Subscriptions API calls (typed). */

import { apiDelete, apiGet, apiPatch, apiPost, type PaginatedResponse, type QueryParams } from "@/lib/api-client";
import type { ApiSubscription } from "./subscriptions.adapter";

export interface SubscriptionsListParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

export const subscriptionsApi = {
  list: (params: SubscriptionsListParams = {}) =>
    apiGet<PaginatedResponse<ApiSubscription>>("/subscriptions", params as QueryParams),
  create: (body: Record<string, unknown>) => apiPost<ApiSubscription>("/subscriptions", body),
  update: (id: string, body: Record<string, unknown>) => apiPatch<ApiSubscription>(`/subscriptions/${id}`, body),
  archive: (id: string) => apiDelete<ApiSubscription>(`/subscriptions/${id}`),
  restore: (id: string) => apiPost<ApiSubscription>(`/subscriptions/${id}/restore`),
};
